import React, { useEffect } from 'react';
import { Route } from 'react-router-dom';
import { useAuth } from 'providers/AuthProvider/SessionAuthProvider';
import Router from 'components/Router/Router';
import ROUTES from 'consts/routes';

const { useLocation, useHistory } = Router;
interface ProtectedRouteProps {
  component: any;
  path: string;
  exact?: boolean;
}

const ProtectedRoute = ({
  component: Component,
  path,
  ...rest
}: ProtectedRouteProps) => {
  const location = useLocation();
  const history = useHistory();
  const { loading, isAuthenticated, setDesiredPath, user } = useAuth();

  useEffect(() => {
    if (loading || isAuthenticated) {
      if (user && (user as any).organization.trial_expired) {
        history.push(ROUTES.TRIAL_EXPIRED);
      }
      return;
    }

    if (!loading && !isAuthenticated) {
      setDesiredPath(location.pathname);
      history.push('/login');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, isAuthenticated, location.pathname, user]);

  const render = (props: any) =>
    isAuthenticated === true ? <Component {...props} /> : null;
  return <Route path={path} render={render} {...rest} />;
};

export default ProtectedRoute;
